<template>
  <div class="page">
    <div class="watch-history">
      <div class="d-flex w-90 page__header">
        <div class="d-flex flex-fill flex-column justify-content-center">
          <div class="page__header-title">Watch History</div>
          <span class="page__header-subtitle"
            >A side by side videos of instructor &amp; user sticks figures</span
          >
        </div>
        <div
          class="d-flex flex-fill justify-content-end align-items-center p-3 page__body"
        >
          <b-input-group>
            <b-form-input
              :value="searchText"
              size="sm"
              placeholder="Search User"
              @input="searchUser"
              trim
            ></b-form-input>
            <!-- <b-input-group-prepend>
              <span class="input-group-text">
                <i class="icon-eye"></i>
              </span>
            </b-input-group-prepend> -->
          </b-input-group>
        </div>
      </div>
      <hr />
      <div
        class="d-flex flex-column justify-content-center watch-history_table_header"
      >
        <div class="d-flex p-3 justify-content-between align-items-center">
          <h6 class="table-title">Users Performed Workout</h6>

          <!-- <span>This Month</span>
        <span>Recent Month</span>-->
          <div class="page__header-filters">
            <div class="filter">
              <label>Start Date</label>
              <b-form-datepicker
                class="filter notranslate"
                size="sm"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                :max="endDate"
                :value="startDate"
                @input="setStartDate"
              ></b-form-datepicker>
            </div>
            <div>
              <label class="filter">End Date</label>
              <b-form-datepicker
                size="sm"
                class="notranslate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                :min="startDate"
                :max="new Date()"
                :value="endDate"
                @input="setEndDate"
              ></b-form-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column watch-history_table">
        <b-table
          small
          striped
          hover
          :items="historyList"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :table-class="'historytable'"
          :thead-class="'row-class row-class-header'"
          @row-clicked="viewHistory"
          :busy="loading"
        >
          <template v-slot:cell(Video)="row">
            <img
              :src="row.item.thumbnail"
              v-if="row.item.thumbnail"
              alt
              srcset
              height="45"
              width="70"
            />
            <img
              v-else
              src="./../../assets/thumbnail.svg"
              height="50px"
              width="50px"
            />
            <span class="pl-2">{{ row.item.title }}</span>
          </template>
          <template v-slot:cell(PerformedOn)="row">
            <span>{{ row.item.dateTime | dateTime }}</span>
          </template>

          <!-- <template v-slot:cell(Initials)="row">
            <div class="watch-history_table-avatar">
              {{ row.item.name.split("")[0][0] }}
            </div>
          </template> -->
          <template v-slot:cell(Name)="row">
            <span class="watch-history_table-name">{{ row.item.name }}</span>
          </template>
          <template v-slot:cell(Duration)="row">
            <span class="pl-2">{{ row.item.videoDuration | hhmmss }}</span>
          </template>
          <template v-slot:cell(Performed)="row">
            <span class="pl-2">{{ row.item.performedDuration | hhmmss }}</span>
          </template>
          <template v-slot:cell(Actions)="row">
            <i class="icon-eye"></i>
            {{ row.item.not }}
          </template>
          <template v-slot:cell(Score)="row">
            <span class="pl-2">{{ row.item.score || 0 }}</span>
          </template>
          <template v-slot:table-busy>
            <loader class="table-busy-state" />
          </template>
        </b-table>
        <noData v-if="!totalRows & !loading"></noData>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-pagination
          size="sm"
          pills
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          id="perPageSelect"
        ></b-pagination>

        <b-form-group
          class="flex-fill"
          label="Items per page"
          label-size="sm"
          label-align="right"
          label-for="perPageSelect"
          label-cols="6"
        >
          <b-form-select
            v-model="perPage"
            :options="perPageOptions"
            required
            size="sm"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
    <!-- <loader /> -->
  </div>
</template>

<script>
import noData from "../components/NoDataAvailable.vue";
import { createNamespacedHelpers } from "vuex";
const {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} = createNamespacedHelpers("admin/watchHistory");
export default {
  components: {
    noData,
  },

  computed: {
    ...mapGetters(["historyList"]),
    totalRows() {
      return this.historyList ? this.historyList.length : 0;
    },
    ...mapState(["searchText", "loading", "endDate", "startDate"]),
  },
  data() {
    return {
      fields: [
        { key: "Initials", label: "" },
        { key: "Name" },
        { key: "Score" },
        { key: "Duration" },
        { key: "Performed" },
        { key: "Video" },
        { key: "PerformedOn" },
        { key: "Actions" },
      ],
      perPage: 5,
      perPageOptions: [5, 10, 15],
      currentPage: 1,
    };
  },
  methods: {
    ...mapActions(["loadHistory", "setStartDate", "setEndDate"]),
    ...mapMutations(["searchUser"]),
    viewHistory(event) {
      this.$router.push(`history/view?id=${event.sessionId}`);
    },
  },

  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadHistory();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },

  mounted() {
    this.loadHistory();
  },

  filters: {
    hhmmss: function (secs) {
      var minutes = Math.floor(secs / 60);
      secs = secs % 60;
      var hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return `${("0" + hours).slice(-2)}:${("0" + minutes).slice(-2)}:${(
        "0" + secs
      ).slice(-2)}`;
    },
    dateTime: function (date) {
      if (!date) {
        return;
      }
      const dateobj = new Date(date);
      return `${dateobj.toDateString()},${dateobj
        .toLocaleTimeString("en-US")
        .replace(/:\d+ /, " ")}`;
    },
  },
};
</script>

<style scoped lang="scss">
// .watch-history {
//   margin-left: 2%;
//   margin-right: 2%;
// }

// .watch-history_header {
//   height: 100px;
//   &--main {
//     font-size: 20px;
//     font-weight: bolder;
//   }
//   &--sub {
//     font-size: 15px;
//     color: #ababab;
//   }
//   border-bottom: 1px solid #ababab;
// }
.watch-history_table_header {
  height: 70px;
  position: relative;
  font-weight: 500;
  &::after {
    position: absolute;
    content: "";
    padding: 2px;
    border-radius: 5px;
    bottom: 0;
    width: 50px;
    background: #37cb79;
  }
}
.watch-history_table {
  font-size: 0.875rem;
  &-name {
    font-weight: bolder;
    color: #fff;
  }
  &-avatar {
    height: 30px;
    width: 30px;
    background: #37cb79;
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    color: white;
  }
}

.historytable th,
.historytable td {
  vertical-align: baseline !important;
}

hr {
  margin: 0;
}

.page__header-filters .filter .label {
  font-weight: 500;
}
.table-busy-state {
  position: relative;
}
</style>
    